import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addAnnounceType from "./components/addAnnounceType";
import { loadMoreList, serchSelect } from "@/mixins/index";
export default {
  name: "announceType",
  components: {
    addAnnounceType: addAnnounceType
  },
  mixins: [loadMoreList, serchSelect],
  data: function data() {
    return {
      paramsData: {
        id: '',
        name: '',
        language: '',
        state: 1
      },
      pagingReqFn: "AnnounceTypes",
      pagingReqValue: "data",
      delIds: [],
      tableBody: 'announceTypeTable',
      sortReq: 'announceTypeChangeSort'
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'delAnnounceType',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};